<template>
  <v-container fluid>
    <Success v-if="success" :result="success" :organization="organization"></Success>
    <OrderForm v-else :tenant="$route.params.tenant" :organization="organization" source="INSPECTECH" @success="done"/>
  </v-container>
</template>

<script>
import OrderForm from '@/components/OrderForm.vue'
import Success from '../components/Success'

export default {
  name: 'home',
  components: {
    Success,
    OrderForm
  },
  data: () => ({
    success: null
  }),
  computed: {
    organization () {
      return this.$store.getters.organization || {}
    }
  },
  methods: {
    done (result) {
      this.success = result
    }
  }
}
</script>
